export default {
  "instagram-downloader": {
    title: "Descargador de Instagram — Descarga Videos y Fotos de Instagram Gratis",
    h1: "Descargador de Instagram",
    desc: "Descarga cualquier video, foto, reel o publicación de carrusel de Instagram gratis. Sin inicio de sesión, sin marca de agua, funciona en iPhone, Android y PC.",
    metaDesc: "Descargador de Instagram gratis — guarda videos, fotos, reels y publicaciones de carrusel de Instagram en HD. Sin marca de agua, sin inicio de sesión. Funciona en iPhone, Android y PC.",
    keywords: "descargador de instagram, descargar videos de instagram, descargador de fotos de instagram, descargador de instagram gratis",
    faq: [
      { q: "¿Cómo descargo videos de Instagram?", a: "Copia la URL del video de Instagram, pégala en InstantSaver, haz clic en Preview y luego en Download. Tu video se guarda en segundos." },
      { q: "¿Puedo descargar fotos de Instagram?", a: "Sí. Pega la URL de la publicación e InstantSaver detecta si es una foto o un video y muestra el botón de descarga correcto." },
      { q: "¿Necesito crear una cuenta?", a: "Nunca se necesita cuenta ni inicio de sesión. InstantSaver es completamente gratuito y anónimo." },
      { q: "¿Los archivos descargados tienen marca de agua?", a: "No. Los archivos se descargan directamente desde el CDN de Instagram en su calidad original — no se añade ninguna marca de agua." },
    ],
    featureTitle: "Qué Puedes Descargar",
    features: [
      { icon: "🎬", text: "Reels de Instagram — video en HD completo" },
      { icon: "🖼️", text: "Fotos y publicaciones del feed" },
      { icon: "🗂️", text: "Publicaciones de carrusel — cada imagen individualmente" },
      { icon: "📺", text: "Videos largos de IGTV" },
      { icon: "👤", text: "Fotos de perfil en calidad original" },
    ],
  },

  "reels-downloader": {
    title: "Descargador de Reels de Instagram — Guarda Reels en HD Gratis",
    h1: "Descargador de Reels de Instagram",
    desc: "Guarda cualquier Reel de Instagram en tu dispositivo en calidad HD. Sin marca de agua, sin registro, funciona al instante en cualquier dispositivo.",
    metaDesc: "Descarga Reels de Instagram en HD gratis. Sin marca de agua, sin inicio de sesión requerido. Guarda reels en iPhone, Android o PC en segundos con InstantSaver.",
    keywords: "descargador de reels de instagram, descargar reels de instagram, guardar reels, descarga de reels gratis",
    faq: [
      { q: "¿Cómo descargo Reels de Instagram?", a: "Abre el Reel en Instagram, toca el menú de tres puntos (⋯) y copia el enlace. Pégalo en InstantSaver y haz clic en Download." },
      { q: "¿Puedo descargar Reels en iPhone?", a: "Sí. InstantSaver funciona en Safari en iPhone. Después de descargar, el video estará en tu app Archivos o Fotos." },
      { q: "¿Puedo descargar Reels en Android?", a: "Sí. El video se guarda automáticamente en la carpeta de Descargas de tu dispositivo." },
      { q: "¿Los Reels descargados son de calidad HD?", a: "Sí. Los Reels se obtienen en su resolución original — hasta 1080p cuando está disponible." },
    ],
    featureTitle: "¿Por Qué Usar InstantSaver para Reels?",
    features: [
      { icon: "⚡", text: "Descarga cualquier Reel público en menos de 5 segundos" },
      { icon: "🔇", text: "Sin marca de agua — archivo original limpio" },
      { icon: "📱", text: "Funciona en iPhone, Android, tablet y escritorio" },
      { icon: "🔒", text: "Nunca se necesita inicio de sesión ni cuenta" },
      { icon: "♾️", text: "Descargas ilimitadas, sin límite diario" },
    ],
  },

  "youtube-downloader": {
    title: "Descargador de Video de YouTube — Descarga Videos de YouTube Gratis",
    h1: "Descargador de Video de YouTube",
    desc: "Descarga videos y Shorts de YouTube gratis. Guarda video MP4 o audio directamente en tu dispositivo — rápido y fácil.",
    metaDesc: "Descargador de video de YouTube gratis. Descarga videos y Shorts de YouTube en formato MP4 o solo audio. No se necesita registro. Rápido y simple.",
    keywords: "descargador de youtube, descargar videos de youtube, descargador de video de youtube, descargador de youtube shorts",
    faq: [
      { q: "¿Cómo descargo videos de YouTube?", a: "Cambia a la pestaña de YouTube en InstantSaver, pega la URL del video, haz clic en Preview y luego en Download." },
      { q: "¿Puedo descargar YouTube Shorts?", a: "Sí. Pega la URL del Short e InstantSaver gestiona la descarga automáticamente." },
      { q: "¿Qué calidad tiene la descarga?", a: "InstantSaver descarga la mejor calidad pre-combinada disponible, normalmente hasta 720p." },
      { q: "¿Puedo descargar solo el audio?", a: "Sí. Después de previsualizar un video, haz clic en el botón Download Audio para obtener la pista de audio M4A." },
    ],
    featureTitle: "Opciones de Descarga de YouTube",
    features: [
      { icon: "🎥", text: "Video MP4 — opciones de 360p, 480p, 720p" },
      { icon: "🎵", text: "Descarga de solo audio M4A" },
      { icon: "⚡", text: "YouTube Shorts — igual que cualquier video" },
      { icon: "🔒", text: "No se requiere cuenta" },
      { icon: "📱", text: "Compatible con móvil y escritorio" },
    ],
  },

  "profile-picture-downloader": {
    title: "Descargador de Foto de Perfil de Instagram — Guarda la Foto en HD",
    h1: "Descargador de Foto de Perfil de Instagram",
    desc: "Descarga la foto de perfil de Instagram de cualquier persona en tamaño completo. Solo pega la URL del perfil y guarda la DP al instante.",
    metaDesc: "Descarga fotos de perfil de Instagram (DP) en calidad original. Pega la URL de cualquier perfil público de Instagram y guarda la foto en tu dispositivo gratis.",
    keywords: "descargador de foto de perfil de instagram, instagram dp downloader, descargar foto de perfil de instagram",
    faq: [
      { q: "¿Cómo descargo una foto de perfil de Instagram?", a: "Ve al perfil de Instagram, copia la URL (ej. instagram.com/usuario), pégala en InstantSaver y haz clic en Download Profile Picture." },
      { q: "¿Puedo descargar la foto de perfil de una cuenta privada?", a: "No. Solo se puede acceder a las fotos de perfil de cuentas públicas sin iniciar sesión." },
      { q: "¿La foto descargada es la versión de tamaño completo?", a: "InstantSaver descarga la imagen de mayor calidad disponible desde el CDN público de Instagram." },
      { q: "¿En qué formato se descarga la foto de perfil?", a: "Las fotos de perfil se guardan como archivos JPEG." },
    ],
    featureTitle: "Cómo Funciona",
    features: [
      { icon: "👤", text: "Funciona con cualquier cuenta pública de Instagram" },
      { icon: "🖼️", text: "Descarga la mayor calidad disponible" },
      { icon: "⚡", text: "Vista previa instantánea antes de descargar" },
      { icon: "🔒", text: "Sin inicio de sesión — anónimo y privado" },
      { icon: "📱", text: "Funciona en todos los dispositivos y navegadores" },
    ],
  },

  "carousel-downloader": {
    title: "Descargador de Carrusel de Instagram — Descarga Todas las Fotos y Videos",
    h1: "Descargador de Carrusel de Instagram",
    desc: "Descarga cada foto y video de una publicación de carrusel de Instagram individualmente o todos a la vez con un clic.",
    metaDesc: "Descarga todas las fotos y videos de publicaciones de carrusel de Instagram. Guarda cada elemento individualmente o usa Download All. Gratis, rápido, sin marca de agua.",
    keywords: "descargador de carrusel de instagram, descargar carrusel de instagram, descargar múltiples fotos de instagram",
    faq: [
      { q: "¿Puedo descargar todas las imágenes del carrusel a la vez?", a: 'Sí. Después de pegar una URL de carrusel, InstantSaver muestra cada elemento con botones de descarga individuales más un botón "Download All".' },
      { q: "¿Qué pasa si un carrusel tiene videos y fotos mezclados?", a: "InstantSaver detecta automáticamente el tipo de cada elemento — las fotos se guardan como JPG, los videos como MP4." },
      { q: "¿Hay un límite de elementos que puedo descargar?", a: "Sin límite. InstantSaver puede detectar y descargar carruseles de hasta 20 elementos." },
      { q: "¿Cómo obtengo el enlace del carrusel?", a: "En Instagram, abre la publicación, toca ⋯ y elige Copy Link. La URL contiene /p/ — eso es una publicación, que puede ser un carrusel." },
    ],
    featureTitle: "Características de Descarga de Carrusel",
    features: [
      { icon: "🗂️", text: "Detecta automáticamente todos los elementos del carrusel" },
      { icon: "⬇️", text: "Botón de descarga individual para cada elemento" },
      { icon: "📦", text: "Botón Download All para guardar todo con un clic" },
      { icon: "🎬", text: "Maneja carruseles mixtos de fotos y videos" },
      { icon: "✨", text: "Vista previa de miniaturas antes de descargar" },
    ],
  },

  "stories-downloader": {
    title: "Descargador de Historias de Instagram — Guarda Historias Antes de que Expiren",
    h1: "Descargador de Historias de Instagram",
    desc: "Guarda cualquier Historia pública de Instagram — foto o video — en tu dispositivo antes de que desaparezca en 24 horas. No requiere inicio de sesión.",
    metaDesc: "Descarga Historias de Instagram gratis. Guarda fotos y videos de historias públicas antes de que expiren. Sin inicio de sesión, sin marca de agua, funciona en cualquier dispositivo.",
    keywords: "descargador de historias de instagram, descargar historia de instagram, guardar historia de instagram",
    faq: [
      { q: "¿Cómo descargo una Historia de Instagram?", a: "Abre la Historia en Instagram, copia su enlace (o el enlace del perfil), pégalo en InstantSaver y haz clic en Download." },
      { q: "¿Puedo descargar una Historia de forma anónima?", a: "Sí. InstantSaver obtiene Historias públicas sin iniciar sesión, y el propietario de la cuenta no recibe ninguna notificación." },
      { q: "¿Puedo descargar Historias de una cuenta privada?", a: "No. Solo se puede acceder a las Historias de cuentas públicas sin iniciar sesión." },
      { q: "¿Qué pasa después de que una Historia expira?", a: "Una vez que una Historia desaparece de Instagram (después de 24 horas, a menos que se guarde como Destacado), InstantSaver ya no puede obtenerla — descárgala antes de eso." },
    ],
    featureTitle: "Por Qué Usar InstantSaver para Historias",
    features: [
      { icon: "⏱️", text: "Guarda Historias antes de que expiren en 24 horas" },
      { icon: "🙈", text: "Anónimo — el autor nunca recibe ninguna notificación" },
      { icon: "🎬", text: "Funciona tanto para Historias de foto como de video" },
      { icon: "🔒", text: "No se necesita inicio de sesión ni cuenta" },
      { icon: "📱", text: "Funciona en iPhone, Android y PC" },
    ],
  },

  "highlights-downloader": {
    title: "Descargador de Destacados de Instagram — Descarga Historias Destacadas Guardadas",
    h1: "Descargador de Destacados de Instagram",
    desc: "Descarga videos y fotos de los Destacados de Historias de un perfil público de Instagram — las historias guardadas fijadas en un perfil.",
    metaDesc: "Descarga Destacados de Instagram gratis. Guarda fotos y videos individuales de los Destacados de Historias fijados en un perfil público.",
    keywords: "descargador de destacados de instagram, descargar destacados de instagram, guardar destacados de instagram",
    faq: [
      { q: "¿Qué son los Destacados de Instagram?", a: "Los Destacados son Historias que un usuario eligió mantener fijadas permanentemente en su perfil, agrupadas en colecciones con nombre." },
      { q: "¿Cómo descargo un Destacado?", a: "Abre el Destacado en el perfil, copia su enlace, pégalo en InstantSaver y haz clic en Download." },
      { q: "¿Puedo descargar todos los elementos de un Destacado a la vez?", a: "Sí, cuando Instagram lo permite — InstantSaver muestra cada diapositiva con su propio botón de descarga." },
      { q: "¿Necesito seguir la cuenta para descargar sus Destacados?", a: "No, siempre que la cuenta sea pública." },
    ],
    featureTitle: "Características de Descarga de Destacados",
    features: [
      { icon: "📌", text: "Funciona con los Destacados fijados de cualquier perfil público" },
      { icon: "🎞️", text: "Descarga diapositivas de foto y video individualmente" },
      { icon: "🔒", text: "No se necesita inicio de sesión ni cuenta" },
      { icon: "📱", text: "Funciona en iPhone, Android y PC" },
    ],
  },
};
